import { AlphaIcon } from "./svg/alpha";
import { usePlans } from "@/hooks/usePlans";
import { CalendarIcon } from "./svg/calendar";
import { DownArrowIcon, UpArrowIcon } from "./svg/arrows";
import { styled as MuiStyled } from "@mui/material/styles";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";

export const BootstrapTooltip = MuiStyled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#FDF6DA",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#FDF6DA",
    color: "rgba(0, 0, 0, 0.87)",
    padding: "1rem",
    maxWidth: 220,
    boxShadow: "5px 6px 11px 0px rgba(0, 0, 0, 0.16)",
  },
}));

export const DesktopFilterPlans = () => {
  const {
    isAlphaOrder,
    isFinalOrder,
    isInitialOrder,
    setIsFinalOrder,
    setIsAlphaOrder,
    setIsInitialOrder,
  } = usePlans();

  return (
    <>
      <BootstrapTooltip
        placement="top"
        title="Classificar por planos mais recentes"
      >
        <div
          className={`down ${isInitialOrder ? 'active' : 'inactive'}`}
          data-testid="ascending_test"
          onClick={() => {
            
            setIsFinalOrder(false);
            setIsInitialOrder(prev => !prev);
          }}
          style={{ background: isInitialOrder ? "#004A80" : "" }}
        >
          <CalendarIcon isClicked={isInitialOrder} />
          <DownArrowIcon isClicked={isInitialOrder} />
        </div>
      </BootstrapTooltip>
      <BootstrapTooltip
        placement="top"
        title="Classificar por planos mais antigos"
      >
        <div
          className={`up ${isFinalOrder ? 'active' : 'inactive'}`}
          data-testid="descending_test"
          onClick={() => {
            setIsInitialOrder(false);
            setIsFinalOrder(prev => !prev);
          }}
          style={{ background: isFinalOrder ? "#004A80" : "" }}
        >
          <CalendarIcon isClicked={isFinalOrder} />
          <UpArrowIcon isClicked={isFinalOrder} />
        </div>
      </BootstrapTooltip>
      <BootstrapTooltip
        placement="top"
        title="Classificar por ordem alfabética"
      >
        <div
          className={`alpha ${isAlphaOrder ? "active" : "inactive"}`}
          style={{ background: isAlphaOrder ? "#004A80" : "" }}
          onClick={() => setIsAlphaOrder(prev => !prev)}
          data-testid="alpha_test"
        >
          <AlphaIcon isClicked={isAlphaOrder} />
        </div>
      </BootstrapTooltip>
    </>
  );
};
